import { render, staticRenderFns } from "./SubpageUsage.vue?vue&type=template&id=1b6e7c60&scoped=true&"
import script from "./SubpageUsage.vue?vue&type=script&lang=js&"
export * from "./SubpageUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6e7c60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b6e7c60')) {
      api.createRecord('1b6e7c60', component.options)
    } else {
      api.reload('1b6e7c60', component.options)
    }
    module.hot.accept("./SubpageUsage.vue?vue&type=template&id=1b6e7c60&scoped=true&", function () {
      api.rerender('1b6e7c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage/SubpageUsage.vue"
export default component.exports